const initialState = {
  data: [],
  loading: true,
  cache: {},
};

export const GetAllClientReceipt = (state = initialState, action) => {
  switch (action.type) {
    case "get_allclientreceipt":
      return {
        ...state,
        data: action.payload,
        loading: action.loader ?? false,
        cache: action.cacheKey
          ? { ...state.cache, [action.cacheKey]: action.payload }
          : state.cache,
      };

    case "set_loading_clientreceipt":
      return {
        ...state,
        loading: action.payload,
      };

    case "clear_clientreceipt_cache":
      return {
        ...state,
        cache: {},
      };

    default:
      return state;
  }
};
